var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveBluetooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.311,
    height: 140,
    viewBox: "0 0 103.311 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bluetooth",
    transform: "translate(-24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2682",
    "data-name": "Raggruppa 2682",
    transform: "translate(24 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3970",
    "data-name": "Tracciato 3970",
    d: "M81.251,34.545,92.766,46.06,81.251,57.575Zm0,70.91L92.766,93.94,81.251,82.425ZM68.914,70.079,43.906,44.914l7.236-7.236,19.906,19.9V9.87l36.2,36.19L83.386,70.087,107.4,94.106l-36.19,36.2V82.425l-20.072,19.9-7.236-7.236,25.008-25ZM75.651,140c30.607,0,51.66-14.481,51.66-70.088C127.311,14.481,106.259,0,75.66,0S24,14.481,24,70.087C24,125.51,45.061,140,75.66,140Z",
    transform: "translate(-24 0)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBluetooth);
export default __webpack_public_path__ + "static/media/move_bluetooth.5a7ee979693400170dc2f60fb6c18872.svg";
export { ForwardRef as ReactComponent };